// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2_qlT","title":"Section_title__3MG2H","titleText":"Section_titleText__3AHwN","chevron":"Section_chevron__1ymU_","turned":"Section_turned__3F1ix"};